import React from "react";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import { ChartTooltip, SERIES } from "./chartTheme";

const tick = { fontSize: 11, fill: "hsl(150, 10%, 46%)", fontFamily: "Segoe UI Regular, sans-serif, system-ui" };

const OutputOverTimeChart = ({ points = [] }) => (
  <ResponsiveContainer width="100%" height="100%">
    <LineChart data={points} margin={{ top: 8, right: 12, bottom: 0, left: -12 }}>
      <CartesianGrid strokeDasharray="3 3" stroke="hsl(140, 8%, 90%)" vertical={false} />
      <XAxis dataKey="label" tick={tick} axisLine={{ stroke: "hsl(140, 8%, 88%)" }} tickLine={false} />
      <YAxis tick={tick} axisLine={false} tickLine={false} allowDecimals={false} width={28} />
      <Tooltip content={<ChartTooltip />} />
      <Legend wrapperStyle={{ fontSize: 11, fontFamily: "Segoe UI Regular, sans-serif, system-ui" }} iconType="plainline" />
      <Line type="monotone" dataKey="hired" name="Hired" stroke={SERIES.hired} strokeWidth={2.5} dot={{ r: 3, fill: SERIES.hired, strokeWidth: 0 }} activeDot={{ r: 5, stroke: "#fff", strokeWidth: 2, fill: SERIES.hired }} />
      <Line type="monotone" dataKey="applied" name="Applications" stroke={SERIES.applied} strokeWidth={2.5} dot={{ r: 3, fill: SERIES.applied, strokeWidth: 0 }} activeDot={{ r: 5, stroke: "#fff", strokeWidth: 2, fill: SERIES.applied }} />
    </LineChart>
  </ResponsiveContainer>
);

export default OutputOverTimeChart;
